export const PROJECT_POWER_LABEL = "Project Power";
export const HABITNU_LABEL = "HabitNu";

export const isAdaApp = () =>
    import.meta.env.VITE_APP_LABEL === PROJECT_POWER_LABEL;
export const isHabitnuApp = () =>
    !import.meta.env.VITE_APP_LABEL ||
    import.meta.env.VITE_APP_LABEL === HABITNU_LABEL;
